/* Prestation Product JavaScript */

window.selectedOptions = window.selectedOptions || [];
window.allVariants = window.allVariants || [];
let currentIndex = 0;

function toggleDropdown(button) {
  document.querySelectorAll('.variant-dropdown').forEach(drop => {
    if (drop.previousElementSibling !== button) {
      drop.classList.remove('show');
    }
  });
  const dropdown = button.nextElementSibling;
  if (dropdown) {
    dropdown.classList.toggle('show');
  } else {
    console.error('Dropdown element not found for button:', button);
  }
}

function selectOption(index, value) {
  window.selectedOptions[index] = value;
  const group = document.querySelectorAll('.variant-group')[index];
  const button = group.querySelector('.variant-button');
  if (button) {
    button.innerText = value;
    button.classList.add('active');
    if (button.nextElementSibling) {
      button.nextElementSibling.classList.remove('show');
    }
  } else {
    console.error('Variant button not found for group index:', index);
  }

  const matchedVariant = window.allVariants.find(v => {
    const option1Match = (window.selectedOptions[0] === undefined || window.selectedOptions[0] === v.option1);
    const option2Match = (window.selectedOptions[1] === undefined || window.selectedOptions[1] === v.option2);
    const option3Match = (window.selectedOptions[2] === undefined || window.selectedOptions[2] === v.option3);
    return option1Match && option2Match && option3Match;
  });

  if (matchedVariant) {
    document.getElementById('product-variant-id').value = matchedVariant.id;
    const price = (matchedVariant.price / 100).toFixed(2).replace('.', ',') + ' €';
    document.querySelector('.add-to-cart-btn .price').innerText = price;
    const priceLabel = window.sectionSettings ? window.sectionSettings.priceLabel : 'Prix :';
    document.getElementById('display-price').innerText = priceLabel + ' ' + price;
    document.querySelectorAll('.loyalty-count').forEach(el => el.innerText = Math.floor(matchedVariant.price / 100));

    const installmentEl = document.getElementById('installment-amount');
    if (installmentEl) {
      const installmentPrice = (Math.floor(matchedVariant.price / 3) / 100).toFixed(2).replace('.', ',') + ' €';
      installmentEl.innerText = installmentPrice;
    }
    const loyaltyPayEl = document.getElementById('loyalty-pay-amount');
    if (loyaltyPayEl) {
      const loyaltyPayPrice = ((matchedVariant.price - 2000) / 100).toFixed(2).replace('.', ',') + ' €';
      loyaltyPayEl.innerText = loyaltyPayPrice;
    }
  } else {
    document.getElementById('product-variant-id').value = '';
    document.querySelector('.add-to-cart-btn .price').innerText = 'N/A';
    const priceLabel = window.sectionSettings ? window.sectionSettings.priceLabel : 'Prix :';
    document.getElementById('display-price').innerText = priceLabel + ' N/A';
    document.querySelectorAll('.loyalty-count').forEach(el => el.innerText = '0');

    const installmentEl = document.getElementById('installment-amount');
    if (installmentEl) installmentEl.innerText = 'N/A';
    const loyaltyPayEl = document.getElementById('loyalty-pay-amount');
    if (loyaltyPayEl) loyaltyPayEl.innerText = 'N/A';
  }
}

function showSlide(index) {
  const carouselInner = document.querySelector('.carousel-inner');
  const carouselItems = document.querySelectorAll('.carousel-item');
  const thumbnailImages = document.querySelectorAll('.product-thumbnails img');

  if (index < 0) {
    currentIndex = carouselItems.length - 1;
  } else if (index >= carouselItems.length) {
    currentIndex = 0;
  } else {
    currentIndex = index;
  }

  carouselInner.style.transform = `translateX(-${currentIndex * 100}%)`;

  document.querySelectorAll('.carousel-dots .dot').forEach((dot, i) => {
    if (i === currentIndex) {
      dot.classList.add('active');
    } else {
      dot.classList.remove('active');
    }
  });

  updateActiveThumbnail();
}

function updateActiveThumbnail() {
  const thumbnailImages = document.querySelectorAll('.product-thumbnails img');
  thumbnailImages.forEach((thumb, i) => {
    if (i === currentIndex) {
      thumb.classList.add('active');
    } else {
      thumb.classList.remove('active');
    }
  });
}

function showThumbnail(index) {
  showSlide(index);
}

function setThumbnailContainerHeight() {
  const mainImageCarousel = document.querySelector('.main-image-carousel');
  const productThumbnails = document.querySelector('.product-thumbnails');

  if (mainImageCarousel && productThumbnails && window.innerWidth >= 768) {
    const mainCarouselComputedHeight = mainImageCarousel.offsetHeight;
    productThumbnails.style.height = `${mainCarouselComputedHeight}px`;
  } else if (productThumbnails && window.innerWidth < 768) {
    productThumbnails.style.height = 'auto';
  }
  updateActiveThumbnail();
}

function initializeCarousel() {
  const carouselInner = document.querySelector('.carousel-inner');
  const carouselItems = document.querySelectorAll('.carousel-item');
  const carouselDotsContainer = document.querySelector('.carousel-dots');
  const mainImageCarousel = document.querySelector('.main-image-carousel');

  if (carouselItems.length > 0) {
    carouselItems.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.classList.add('dot');
      if (index === 0) {
        dot.classList.add('active');
      }
      dot.addEventListener('click', () => {
        showSlide(index);
      });
      carouselDotsContainer.appendChild(dot);
    });

    showSlide(0);

    // Touch events for carousel (mobile and desktop)
    let startX;
    let initialClientY;
    carouselInner.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      initialClientY = e.touches[0].clientY;
    }, { passive: false });

    carouselInner.addEventListener('touchmove', (e) => {
      if (startX === undefined || startX === null) return;
      let currentX = e.touches[0].clientX;
      let diffX = startX - currentX;

      const currentY = e.touches[0].clientY;
      const deltaY = Math.abs(currentY - initialClientY);

      if (Math.abs(diffX) > Math.abs(deltaY) && Math.abs(diffX) > 10) {
        e.preventDefault();
      }
    }, { passive: false });

    carouselInner.addEventListener('touchend', (e) => {
      if (startX === undefined || startX === null) return;
      let endX = e.changedTouches[0].clientX;
      let diffX = startX - endX;

      if (diffX > 50) {
        showSlide(currentIndex + 1);
      } else if (diffX < -50) {
        showSlide(currentIndex - 1);
      }
      startX = null;
      initialClientY = null;
    });

    // Mouse drag events for carousel (desktop)
    let isDragging = false;
    let dragStartX;

    carouselInner.addEventListener('mousedown', (e) => {
      isDragging = true;
      dragStartX = e.clientX;
      carouselInner.style.cursor = 'grabbing';
    });

    carouselInner.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
    });

    carouselInner.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      carouselInner.style.cursor = 'grab';

      let dragEndX = e.clientX;
      let diffX = dragStartX - dragEndX;

      if (diffX > 50) {
        showSlide(currentIndex + 1);
      } else if (diffX < -50) {
        showSlide(currentIndex - 1);
      }
    });

    carouselInner.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        carouselInner.style.cursor = 'grab';
      }
    });

  } else {
    // Fallback for no media
    if(mainImageCarousel) {
      mainImageCarousel.innerHTML = `
        <div class="carousel-item">
          <img src="https://via.placeholder.com/600" alt="Produit">
        </div>
        <button class="tag-badge">PRESTATION SALON DE COIFFURE</button>
        <button class="favorite-btn" onclick="window.location.href='/account/favorites'">
          <img src="https://cdn.shopify.com/s/files/1/0729/3983/1631/files/favori_image_grenadine.png?v=1747835462" alt="Favori">
        </button>
      `;
    }
  }

  // Initial call to set thumbnail height
  setTimeout(setThumbnailContainerHeight, 100);

  // Re-calculate on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setThumbnailContainerHeight, 200);
  });

  // Ensure main carousel image has loaded
  const mainCarouselImage = mainImageCarousel ? mainImageCarousel.querySelector('img') : null;
  if (mainCarouselImage && !mainCarouselImage.complete) {
    mainCarouselImage.addEventListener('load', () => {
      setThumbnailContainerHeight();
      showSlide(0);
    });
  }
}

function initializeDescriptionTruncation() {
  const descriptionContainer = document.querySelector('.product-description-container');
  if (descriptionContainer) {
    const readMoreBtn = descriptionContainer.querySelector('.read-more-btn');

    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', () => {
        const readMoreText = window.sectionSettings ? window.sectionSettings.readMoreText : 'Lire la suite...';
        const readLessText = window.sectionSettings ? window.sectionSettings.readLessText : 'Moins';

        if (descriptionContainer.classList.contains('expanded')) {
          descriptionContainer.classList.remove('expanded');
          readMoreBtn.innerText = readMoreText;
        } else {
          descriptionContainer.classList.add('expanded');
          readMoreBtn.innerText = readLessText;
        }
      });
    }
  }
}

function initializeVariantButtons() {
  // Attach event listeners to variant toggle buttons
  document.querySelectorAll('[data-toggle-dropdown]').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      toggleDropdown(this);
    });

    // iOS Safari specific touch event
    button.addEventListener('touchend', function(e) {
      e.preventDefault();
      toggleDropdown(this);
    }, { passive: false });
  });

  // Attach event listeners to variant option buttons
  document.querySelectorAll('[data-option-value]').forEach(button => {
    const index = parseInt(button.getAttribute('data-option-index'));
    const value = button.getAttribute('data-option-value');

    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      selectOption(index, value);
    });

    // iOS Safari specific touch event
    button.addEventListener('touchend', function(e) {
      e.preventDefault();
      selectOption(index, value);
    }, { passive: false });
  });
}

function initializeFavoriteButton() {
  const favoriteBtn = document.querySelector('.favorite-btn[data-favorite-url]');
  if (favoriteBtn) {
    const url = favoriteBtn.getAttribute('data-favorite-url');

    favoriteBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.location.href = url;
    });

    // iOS Safari specific touch event
    favoriteBtn.addEventListener('touchend', function(e) {
      e.preventDefault();
      window.location.href = url;
    }, { passive: false });
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  initializeCarousel();
  initializeDescriptionTruncation();
  initializeVariantButtons();
  initializeFavoriteButton();

  // Close dropdowns when clicking outside
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.variant-group').forEach(group => {
      const button = group.querySelector('.variant-button');
      const dropdown = group.querySelector('.variant-dropdown');
      if (button && dropdown && !button.contains(event.target) && !dropdown.contains(event.target)) {
        dropdown.classList.remove('show');
      }
    });
  });

  // Loyalty popup click handler
  document.querySelectorAll('.loyalty-count, .brand img').forEach(el => {
    el.style.cursor = "pointer";
    el.addEventListener('click', () => {
      document.getElementById('popup-fidelite').style.display = 'flex';
    });
  });

  // Hide popup if clicked outside
  const popupFidelite = document.getElementById('popup-fidelite');
  if (popupFidelite) {
    popupFidelite.addEventListener('click', function(event) {
      if (event.target === this) {
        this.style.display = 'none';
      }
    });
  }
});
